import React from 'react';

export const TwitterIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4772 10.7312L19.2401 4H17.894L12.8611 9.84101L8.81916 4H7.47306H5.45406H5.23709H4.10828L10.2217 12.9045L4.10828 20H5.54104L10.8424 13.8081L15.0934 20H15.3324H16.5265H18.4589H18.9148H19.8916L13.4772 10.7312ZM6.2054 5.08549H8.21848L12.0947 10.7309L10.9951 12.0071L6.2054 5.08549ZM15.7752 18.9148L11.6161 12.9048L12.7098 11.6273L17.7131 18.9148H15.7752Z"
      fill="#444D55"
    />
  </svg>
);
